module.exports = __webpack_public_path__ + "media/images/graph-53e1d56a4be956b0faea291a6e74db27.svg";